import { render, staticRenderFns } from "./AddressCustomerShipto.vue?vue&type=template&id=93bfbdd6"
import script from "./AddressCustomerShipto.vue?vue&type=script&lang=js"
export * from "./AddressCustomerShipto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports